/* eslint max-classes-per-file: 0 */

import {
  Mark as Data,
  MarkCollection as Collection,
} from '@/typings/api/Marks'

import { BaseMarksApiAuth } from '@/api/BaseApiAuth'
import {
  BaseApiParams,
  BaseApiResponse,
} from '@/typings/common'
import { AxiosRequestConfig } from 'axios'
import isNil from 'lodash/isNil'

export class MarksFilesApi extends BaseMarksApiAuth<Data, Collection> {
  protected readonly endpoint = 'files';

  protected readonly hasFinishSlash = false;

  public upload(p: BaseApiParams, config?: AxiosRequestConfig) {
    const path = 'upload'
    const data = new FormData()
    Object.entries(p).forEach(([k, v]) => {
      if (!isNil(v)) data.append(k, v as string | Blob)
    })
    const [url] = this.getUrl(path)
    return this.request<never, BaseApiResponse<Data>>(
      'POST',
      url,
      { data, ...config },
    )
  }

  public download(fileId: number) {
    const path = `download?file_id=${fileId}`
    const [url] = this.getUrl(path)
    return url
  }
}
